import { Box, Icon, Spacer, Text } from '@jfs/ui-new'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { staticStrings } from '../../data/static/strings'
import { RootStore, useStores } from '../../data/store'
import { FileSelector } from './FileSelector'
import styles from './styles'
import { UploadFileProgress } from './UploadFileProgress'

interface FileUploadProps {
  tabIndex: number
  onFileSelected: any
  mid: string
  progress: any
  name: any
  onHandleCancelChangeFile: any
  navToHistory: any
  handleDownloadSampFile: any
  file: any
  resetState: any
}

const FileUpload = ({
  tabIndex,
  onFileSelected,
  mid,
  progress,
  name,
  onHandleCancelChangeFile,
  navToHistory,
  handleDownloadSampFile,
  file,
  resetState,
}: FileUploadProps) => {
  const { uploadStatus } = useStores((store) => ({
    uploadStatus: store?.bulkRefund?.uploadStatus,
  }))

  const themedStyle = styles(0)

  return (
    <>
      {/** File Chooser */}
      {uploadStatus === 'NOT_SELECTED' && (
        <Box alignItems={'center'} justifyContent={'center'}>
          <FileSelector
            onFileSelect={onFileSelected}
            mid={mid}
            onError={(err: string) => RootStore?.response?.setMessage(err)}
          />
          <Spacer size={16} />
          <ModBox show={tabIndex === 0}>
            <Text fontSize={12} fontFamily={'jiotype-medium'} color={'BLACK_75'}>
              {'Input File format should be as per the Sample File format.'}
            </Text>
          </ModBox>
          <Spacer size={16} />
          <Box {...themedStyle.downloadSampfile} onPress={handleDownloadSampFile} testID={'downloadSampleFile'}>
            <Box direction={'row'}>
              <Icon color={'BLUE'} id={'DOWNLOAD'} />
              <Spacer direction={'horizontal'} size={8} />
              <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLUE'}>
                {staticStrings.downloadSampleFile}
              </Text>
            </Box>
          </Box>
        </Box>
      )}
      {/** Upload Progress */}
      {uploadStatus !== 'NOT_SELECTED' && (
        <UploadFileProgress
          progress={progress}
          fileName={name ?? ''}
          onHandleCancelChangeFile={onHandleCancelChangeFile}
          mid={mid}
          navToHistory={navToHistory}
          file={file}
          resetState={resetState}
        />
      )}
    </>
  )
}

export { FileUpload }
